/*
 *
 *@description:
 *@modifyContent: 路演相关
 *@author: qiuhongyang
 *@date: 2020-07-29 13:25:02
 *
*/

import { getLkApi, getGubaApi } from '../modules/apidata';
import { debounce, dateFormat, getQueryParams } from '../../src/modules/utils';
import cookie from '../../src/modules/cookie/index';
import changeVedios from '../../src/modules/video_wz';
import { generalValidate } from '../../src/modules/langke/commonapi';  //权限认证
import {
  loadBaseInfo,
  freshBaseData,
  // loadChatTabs,
  loadAgenda,
  sharebox,
  getKaPianInfo,
  loadGuests,
  gbposterbox,
  smallvedioCtrl,
  wechatQRcode,
  loadPropagateVideo,
  wzluyanIM,
  showLoading,
  hideLoading,
  calculateEnter,
  tiwenTip,
  generateAuthentic,
  forbidAdminChat,
  forbidChat,
  getCover,
  formatVideoList
} from "./components/ly_othermodalinfos/wzluyan";
import tiptoast from '../../src/modules/modal/tiptoast';
// import smallmodal from '../../src/modules/modal/smallmodal';  // 小弹窗
import _, { identity } from 'lodash';
import moment from 'moment';
import transFace from "../../src/modules/face";
import PreViewPicture from "../../src/modules/previewimg";
import loadChatTabs from "../../src/modules/luyanchatdom/chattabs";
import getChatDomList from "../../src/modules/luyanchatdom";
import bindChatEvens from "../../src/modules/luyanchatdom/bindevent"; // 互动事件绑定


declare let urlid: any;  //id

let _env = "production";
// if (window.location.hostname != 'roadshow.eastmoney.com') {
//   _env = "test";
// };

let accountInfo: any = {
  lkCToken: '',
  lkUToken: '',
  id: urlid || ""
};

let _zbstatus: any = ""; //全局直播状态 

// 避免重复加载视频标记
let _livechapter = false, _backchapter = false, _forecgapter = false;

let myQuestionInitData = []; //我的提问缓存数组

let baseinfo = {} as any;

/** 为true 时才显示主持人或嘉宾视角 */
let isAdmin = getQueryParams("admin") == 1;  // url是否是特殊用户标识


let luyan = {
  //获取浪客通行证相关信息 /api/getlkinfos
  getlkinfos: async function () {
    let infos = await $.ajax({
      url: '/api/getlkinfos',
      type: 'GET',
      dataType: 'json'
    });

    accountInfo = $.extend(accountInfo, infos.result);

    return accountInfo;
  },
  /**
   * 白名单验证信息:generate 权限验证
   *
   * @returns
  */
  getAuthInfos: async function () {
    let obj = {
      channel_id: urlid,
      password: "",
      view_type: 4
    }
    return generalValidate(obj);
  },
  init: async function () {
    let that = this;
    accountInfo = await that.getlkinfos();

    let uid: any = cookie.get('uidal') || cookie.get('uid');
    this.uid = (uid || "").substr(0, 16); //用户uid
    this.name = decodeURIComponent((uid || "").substr(16));//用户名

    // 权限验证
    let authinfo = await that.getAuthInfos();

    generateAuthentic(authinfo);

    // enter 统计及以后的权限验证
    await calculateEnter(authinfo, accountInfo);

    this.isLangKeRoom = true; // 是否是浪客直播间
    this.isSpecialStatus = false;//身份为嘉宾或者主持人 为True
    this.type = 0; //股吧评论列表类型,1:我的提问,2：提到我的,3:未回答,4:已回答
    this.preListLen = 0;
    this.lastid = "";//不传则获取最新评论，下拉查看历史留言时传当前最后一条的留言id
    this.lasttime = "";//形如 yyyy-MM-dd HH:mm:ss ,下拉查看历史留言时传当前最后一条的留言时间, 嘉宾视角传留言时间，用户视角下若是嘉宾回答则传嘉宾回答时间
    this.operatetime = ""; // 如上：预告状态下的操作时间
    this.isFirstLoadList = true;//是否第一次加载股吧

    this.firstListId = "";//用于记录加载时第一条数据
    this.firstListAnswerId = "";//用于记录加载时第一条数据的回复id
    this.isMySeter = null;
    this.getData();
    this.event();
    // this.getCampanyInfos();

    this.stockinfo = {};

    // 
    myQuestionInitData = await that.getInitMyQuestionData();


  },

  /**
   * 刷新直播视频:现在只考虑视频直播结束
  */
  freZBVideo: function (can_comment: any, baseinfo: any) {
    let that = this;
    try {
      getLkApi('/api/comment/status', {
        channel_id: accountInfo.id
      }).then(function (res) {
        let data = res?.data;
        //直播结束 1直播4预告3回顾 
        //status 指的是文字直播的状态!!!
        if (data?.status == 1 || data?.status == 3 || data?.status == 4) {
          that.zbLuyanVideo(res.data);

          forbidChat(data?.status, can_comment);
        };

      });
    } catch (error) { }
  },

  /**
   * 视频直播结束到文字直播结束之间事件
   * 只考虑视频直播结束状态:回顾->预告->封面->看回顾提示封面
   * 
   * let _livechapter = false,_backchapter = false,_forecgapter = false;
  */
  zbLuyanVideo: function (res: any, fromIM?: boolean) {
    let that = this;

    try {
      let status = res?.status;

      $("#vedioCtrlBox").css({ "min-height": "366px", "width": "650px" });
      //视频实例化
      let showvideo = (newarr, emavid) => {
        if (newarr.length < 1) return false;

        if ($("#vedioCtrlBox").find(".wz-video-wrap").length < 1) {
          $("#vedioCtrlBox").append($(`<div id="wz-video-wrap" class="wz-video-wrap"></div>`))
        };

        $(".playcovermask").remove();

        let v = new changeVedios({
          boxid: "wz-video-wrap",
          data: newarr,
          emavid: emavid,
          status: status
        });
        v.init();
      };

      let livechapter = res?.live_chapter;   //直播
      let forelist = res?.foreshow_chapter;  //预告
      let backlist = res?.playback_chapter;  //回顾
      // let cover = res?.cover;  //封面
      let cover = getCover(baseinfo || res) // 封面h-cover > cover > V-cover
      let huigumask = "";

      //直播
      if (livechapter && livechapter.length > 0 && status == 1 && livechapter?.[0]?.media_group?.[0]?.media?.url) {
        if (!_livechapter || fromIM) {
          let avid = "av-player" + parseInt(<any>(Math.random() * 10000))
          let arr = formatVideoList(livechapter, avid);
          let mediagroup = arr[0]?.media_group.filter(function (v) {
            return v.format == "hls"
          });
          arr[0].media_group = mediagroup;
          if (!mediagroup?.length) {
            $("#vedioCtrlBox").css({ "min-height": "0px", "width": "650px" });
          } else {
            _livechapter = true;
            showvideo(arr, avid);

            return false;
          }
        }
        return false;
      };

      //回顾视频
      if (backlist && backlist.length > 0 && status == 3 && backlist?.[0]?.media_group?.[0]?.media?.url) {

        if (!_backchapter) {
          $("#wz-video-wrap").empty();
          let arr = formatVideoList(backlist, "av-player1");
          showvideo(arr, "av-player1");
          _backchapter = true;
        }
        return false;
      };

      //预约视频处理 
      if (forelist && forelist.length > 0 && (status == 4)) {  //预告和回顾  20210413修改status == 3 
        if (!_forecgapter || fromIM) {
          let avid = "av-player2" + parseInt(<any>(Math.random() * 10000))
          let arr = formatVideoList(forelist, avid);
          showvideo(arr, avid);
          _forecgapter = true;
          return false;
        }
        return false;
      };

      //封面
      if (cover) {
        let huigumask = `<div id="" class="playcovermask" style="background-image: url(${cover})"></div>`
        $("#vedioCtrlBox").empty().append($(huigumask));
        return false;
      };

      //否则隐藏
      // $("#vedioCtrlBox").css({ "min-height": "0", "width": "650px" });
      $("#vedioCtrlBox").css({ "background": "#000", "width": "650px" }); // 黑框兜底
      $("#vedioCtrlBox").empty();
    } catch (error) { }
  },

  /**
   * 综合数据
  */
  getData: async function () {
    let that = this;
    let json = await getLkApi('/api/Roadshow/Detail', {
      channel_id: accountInfo.id
    })
    if (!json || !json?.data) {
      return;
    }

    let curstatus = json?.data?.status;
    _zbstatus = curstatus;
    this.dealData(json);

    this.getCommentData().then(() => {
      if (curstatus != 3) {
        this.loadCallback();
      }

    });

    wechatQRcode(json?.data); //微信分享重写

    let can_comment = json?.data?.intercation_config?.can_comment; //是否开启评论

    setInterval(async function () {
      let json = await getLkApi('/api/Roadshow/Detail', {
        channel_id: accountInfo.id
      });

      //直播才刷新头部动态信息
      if (curstatus == 1 || curstatus == 4) {
        // loadBaseInfo(json.data,that.isSpecialStatus);    
        freshBaseData(json.data); // 不要整个模块刷新
      };

      // 刷新直播视频
      let can_comment = json?.data?.intercation_config?.can_comment; //是否开启评论

      that.freZBVideo(can_comment);
      baseinfo = json?.data;

      wechatQRcode(json?.data); //微信分享重写

      $("#shareTop").show();
      // that.freshZbStatus(json);

      // 由预告到直播 刷新用户视角发言列表  _zbstatus
      if (json?.data?.status == 1 && _zbstatus == 4 && !that.isSpecialStatus) {
        _zbstatus = 1;
        $('.luyan_content ul').empty();
        that.refresh();
      };

    }, 60 * 1000);

    // that.freshZbStatus(json);

    if (curstatus == 1 || curstatus == 3 || curstatus == 4) {
      // initvideo
      that.freZBVideo(can_comment);
      baseinfo = json?.data;
    };

    // 预告且开放提问
    // if (curstatus == 4 && can_comment && !this.isSpecialStatus) {
    //   tiwenTip.call(this)
    // }
    if (curstatus == 4 && can_comment && !isAdmin) {
      tiwenTip.call(this)
    }


    // IM事件
    wzluyanIM.call(this, json?.data);

  },
  /**
  * 判断是不是浪客直播间 type = 1 && source not in ( 101,108,109)
  */
  getRoomPlat: function (type: number, source: number) {
    return type == 1 && [101, 108, 109].indexOf(source) < 0
  },

  /**
   * 处理数据执行方法
   */
  dealData: function (json) {
    let that = this;
    let data = json.data;
    // 获取主持人id列表
    this.presentersId = [];

    // 主持人信息
    this.presentersInfo = {};

    if (data.presenters) {
      this.presentersId = data.presenters.map(item => {
        this.presentersInfo[item.emuid] = item
        return item.emuid;
      })
    }

    this.isLangKeRoom = this.getRoomPlat(data.type, data.source);

    this.sourcetype = data?.source;
    // alert(isLangKeRoom)

    // 嘉宾信息
    this.guestsInfo = {}
    // 获取嘉宾id列表
    this.guestsId = [];

    if (data.guests) {
      this.guestsId = data.guests.map(item => {
        this.guestsInfo[item.emuid] = item
        return item.emuid;
      })
    }

    // console.log('guestID', this.guestsId)

    // 判断是否为嘉宾或者支持人
    let user_type: number = data?.user?.user_type;
    this.isSpecialStatus = user_type == 1 || user_type == 3 || user_type == 100;

    // this.isSpecialStatus = true;
    this.isguest = this.guestsId.indexOf(this.uid) != -1; //是否为嘉宾
    this.isPresenter = this.presentersId.indexOf(this.uid) != -1; //是否为主持人
    this.status = data.status;//直播状态
    this.guests = data.guests || []; //嘉宾数据
    this.agendas = data.agendas || [];//议程数据
    this.initLuyanVideo(data, "av-player-ctx12");
    loadBaseInfo(data, this.isSpecialStatus);
    loadGuests.call(this);
    loadAgenda.call(this);
    // loadChatTabs.call(this,isLangKeRoom)
    loadChatTabs(this.isLangKeRoom, this.isSpecialStatus, this.isPresenter, this.isguest, isAdmin);
    let can_comment = data?.intercation_config?.can_comment; //是否开启评论
    this.initGubaEditer(can_comment);

    getKaPianInfo(data?.anchor?.emuid, this.isSpecialStatus, isAdmin);

    this.loadVideo(data?.propaganda_video?.url)

    setTimeout(() => {
      forbidAdminChat(this.isSpecialStatus, isAdmin, this.isPresenter)
    }, 500);
  },

  /*
   *@Title:  j初始化视频
   *@params1: res 原始数据
   *@params2: emavid 必传参数，不能为空，且不能一样
   *@author: qiuhongyang
   *@date: 2021-02-26 10:55:42
   *
  */
  initLuyanVideo: function (res, emavid) {
    try {
      $("#vedioCtrlBox").css({ "min-height": "0", "width": "650px" });
      let status = res.status, list: any = [];
      if (status == 1) {
        list = res?.live_chapter;
        // return false;  //如果直播则走 comments/status
      }
      if (status == 3) {

        return false;
        //true 且无播放视频l
        // let playbackchapter = res?.playback_chapter?.[0];
        // if (res?.playback && !playbackchapter?.media_group?.[0]?.media?.url) {
        //   $("#vedioCtrlBox").css({ "min-height": "366px", "width": "650px" });
        //   let maskstr = `<div id="playbackmask" class="playbackmask" style="display:block">
        //       <div class="box">
        //         <span class="txt1">直播已结束</span>
        //         <span class="txt2" id="playHuiguVideo">看回顾</span>
        //       </div>
        //     </div>`
        //   $("#wz-video-wrap").empty();
        //   $("#vedioCtrlBox").append($(maskstr));
        //   $("#playbackmask").show();
        //   return;
        // }
        // list = res?.playback_chapter;
      }
      if (status == 4) {
        list = res?.foreshow_chapter;
      };
      if (!list || list.length < 1) return;

      let newarr = list.filter(function (v) {
        v.emavid = emavid;
        return v.media_group.length > 0 && !!v.media_group[0]?.media?.url
      });

      //如果是直播 只取hls格式的
      if (status == 1) {
        let mediagroup = list[0]?.media_group.filter(function (v) {
          return v.format == "hls"
        });
        newarr[0].media_group = mediagroup

        if (!mediagroup?.length) {
          $("#vedioCtrlBox").hide();
          return false;
        }
      };
      // console.log(newarr)

      if (newarr && newarr?.length > 0) {
        if ($("#vedioCtrlBox").find(".wz-video-wrap").length < 1) {
          $("#vedioCtrlBox").append($(`<div id="wz-video-wrap" class="wz-video-wrap"></div>`))
        };
        $("#vedioCtrlBox").css({ "min-height": "366px", "width": "650px" });
        $("#playbackmask").remove();  //有回顾则remove
        if (status == 1) {
          _livechapter = true;
        }
      } else {
        return false
      };

      let v = new changeVedios({
        boxid: "wz-video-wrap",
        data: newarr,
        emavid: emavid,
        status: status
      });
      v.init();
    } catch (error) { }
  },
  /**
   * 宣传视频
   * @param src 视频地址 
   */
  loadVideo: function (src) {
    if (!src) { return false };
    // loadPropagateVideo(src, _env)  // 去掉简介模块
  },

  /**
   * 刷新列表
   */
  refresh: function () {
    this.isFirstLoadList = true;
    this.lastid = '';
    this.lasttime = '';
    this.operatetime = '';
    this.preListLen = 0;
    $('.luyan_content ul').html("")
    this.getCommentData();
  },

  // 获取初次我的提问数据
  getInitMyQuestionData: async function () {
    let back = [];

    let json = await getGubaApi('wzzb/JSONP/GetLiveUserReplyList', {  //
      tid: accountInfo.id,
      lastid: '',
      lasttime: '',
      type: 59,
      ps: 20,
      order: 1,
      listtype: 1
    });
    if (json && json?.re && json?.re?.length > 0) {
      back = json.re;

      myQuestionInitData = json.re

      // console.log(myQuestionInitData)
    }

    return back;

  },

  /**
   *  普通用户我的提问新消息提醒
   * @returns 
   */
  getMyQuestionData: async function () {
    try {
      if (this.isSpecialStatus || this.type != 0) { return; }
      let json = await getGubaApi('wzzb/JSONP/GetLiveUserReplyList', { //reply/JSONP/GetLiveUserReplyList
        tid: accountInfo.id,
        lastid: '',
        lasttime: '',
        type: 59,
        ps: 20,
        order: 1,
        listtype: 1
      });
      if (json && json.re && json.re.length && json.re.length > 0) {
        for (var i = 0; i < json.re.length; i++) {
          let predata: any = myQuestionInitData[i];
          let curitem = json.re[i];

          if (myQuestionInitData.length == 0 && curitem.answer_id > 0) {
            $('.luyan_tabs >li[data-id="1"]').addClass('dot');
            myQuestionInitData = json.re;
            break
          }

          if (predata.answer_id != curitem.answer_id) {
            $('.luyan_tabs >li[data-id="1"]').addClass('dot');

            myQuestionInitData = json.re;

            break;
          }
        }
      }
    } catch (error) { }
  },

  /**
   * 获取股吧接口数据
   */
  getGubaApiData: async function (isNew: boolean = false) {
    let that = this;
    //默认全部下的数据
    let _url: string = 'wzzb/JSONP/GetLiveAllReplyList'; // reply换成wzzb
    let order = that.ordertype == undefined ? 1 : that.ordertype;

    // 回顾且普通视角
    if (_zbstatus == 3 && !this.isSpecialStatus && that.type != 1) { //&& !this.isSpecialStatus
      order = 0
    };
    // 回顾且特殊视角
    if (_zbstatus == 3 && this.isSpecialStatus && that.ordertype == undefined) {
      order = 0;
      $("#chat_order_asc").addClass("on").siblings().removeClass("on")
    };

    // 直播之前且不是嘉宾主持人 operatetime 
    let lasttime = _zbstatus == 4 && !this.isSpecialStatus ? that.operatetime : that.lasttime;

    // “全部”列表参数：区分普通和特殊
    let options: any = {
      uid: that.uid,
      tid: accountInfo.id,
      lastid: that.lastid,
      liveStatus: _zbstatus, // 直播状态
      lasttime: lasttime,
      type: 59,
      ps: 20,
      order: order,  // 1:获取比lastid老的,0:获取比lastid新的,原来默认1
      userView: isAdmin ? 0 : 1 // 传1给用户视角，不传或传0还是之前的逻辑
    };

    // 其他类别的数据
    if (this.type != '0') {
      _url = 'wzzb/JSONP/GetLiveUserReplyList';
      // options.listtype = this.type;
      // 非“全部”列表参数保持不变
      options = {
        tid: accountInfo.id,
        lastid: that.lastid,
        lasttime: lasttime,
        type: 59,
        ps: 20,
        listtype: this.type,
        order: order  //1:获取比lastid老的,0:获取比lastid新的,原来默认1
      }
    };

    if (isNew) {
      options.lastid = "";
      options.lasttime = "";
      options.operatetime = "";
    };

    let json = await getGubaApi(_url, options)

    if ((json && json.re && json.re.length) || json?.fake_re?.length) {
      let fake_re: Array<any> = json?.fake_re || []; //接口假数据
      let data: Array<any> = fake_re.concat(json.re)
      return data
    };

    return false;
  },
  /**
   * 定时刷新最新数据
   */
  refreshNewData: async function () {
    let that = this;
    try {
      let specialOnReply = that.checkOnReplyStatus(); // 主持人或嘉宾回复状态

      // 非嘉宾 或者嘉宾且没有回复时直接刷列表
      // if (!this.isSpecialStatus || (!onReply && this.isSpecialStatus)) {
      if (!this.isSpecialStatus || (!specialOnReply && this.isSpecialStatus)) {
        // $(".luyan_tabs").find(".active").trigger("click");
        that.type = $(".luyan_tabs").find(".active").data('id');
        that.isFirstLoadList = true;
        that.lastid = '';
        that.lasttime = '';
        that.operatetime = "";
        that.preListLen = 0;
        $('.luyan_content ul').html("")
        that.getCommentData();
      }

      // 嘉宾或主持人且正在回复时候视角
      if (this.isSpecialStatus) {
        if (specialOnReply) return false; // 正在回复不更新
        let json = await this.getGubaApiData(true);
        let newData: Array<any> = [];
        if (json) {
          for (let i = 0; i < json.length; i++) {

            // 最新的数据列表依次和上次的第一条比较
            if (json[i].reply_id != this.firstListId || (json[i].reply_id == this.firstListId && json[i].answer_id != this.firstListAnswerId)) {
              newData.push(json[i]);

              // 上次的第一条数据获得了回复
              if (json[i].reply_id == this.firstListId) {
                break;
              };

            } else {
              break
            };
          }
          if (newData.length) {
            $(".jiafaChat").remove();
            let html: string = this.getGubaListDom(newData);
            $('.luyan_content ul').prepend(html);
            this.firstListId = newData[0].reply_id; // 重新赋值
            this.firstListAnswerId = newData[0].answer_id;
          }
        }
      }
    } catch (error) {

    }
  },

  loadCallback: function () {

    //定时刷数据
    setInterval(() => { this.refreshNewData() }, 60000)

    //我的提问 消息提醒
    setInterval(() => { this.getMyQuestionData() }, 60000)
  },
  /**
   * 调取股吧列表数据
   */
  getCommentData: async function () {
    let json = await this.getGubaApiData()

    if (json) {
      //加载列表
      this.loadGubaList(json);
    } else if (this.isFirstLoadList) {
      $('.luyan_content ul').html('<li class="noDate" style="width:648px;height:500px"></li>')
    }
  },
  /**
   * 获取股吧发言框 要求数据
   * @param opt 
   */
  getGubaPostData: function (opt = {}) {
    let postData: any = {
      tid: accountInfo.id,
      liveStatus: this,
      // isGuest:false,
      userType: '1',
      guestPhoto: '',
      guestUid: '',
      guestIdentity: '',
      guestName: '',
      guestList: this.guestList,
      type: this.sourcetype
    };

    if (this.isSpecialStatus) {
      // 嘉宾或者主持人  
      let guest = this.guestsInfo[this.uid] || this.presentersInfo[this.uid];
      let isguest = this.guestsInfo[this.uid];
      let userType = isguest ? 2 : 3; //userType:1普通用户；2：嘉宾；3：主持人

      //如果是主持人则显示主持人20200703待处理
      let guestname = guest?.target_nickname || guest?.nickname;
      postData = $.extend(postData, {
        // isGuest:true,
        userType: userType,
        guestPhoto: guest.avatar,
        guestUid: guest.emuid,//嘉宾id
        guestIdentity: guest.position,//嘉宾身份
        guestName: guestname,//嘉宾姓名
        guestShowName: guestname || ""
      }, opt);
    }
    return postData;
  },
  /**
   * 修改发言参数
   * @param opt 
   */
  getGubaPostDataForEdit: function (opt = {}) {
    let postData: any = {
      tid: accountInfo.id,
      liveStatus: 1,
      userType: 3,// userType：2嘉宾 ；userType：3主持人
      guestPhoto: '',
      guestUid: '',
      guestIdentity: '',
      guestName: '',
      guestList: this.guestList
    };
    // 嘉宾或者主持人  
    let guest = this.guestsInfo[this.uid] || this.presentersInfo[this.uid];
    let guestname = guest?.target_nickname || guest?.nickname;
    postData = $.extend(postData, {
      guestPhoto: guest.avatar,
      guestUid: guest.emuid,//嘉宾id
      guestIdentity: guest.position,//嘉宾身份
      guestName: guestname//嘉宾姓名
    }, opt);

    return postData;
  },
  /**
   * 初始化发言框
   */
  initGubaEditer: function (can_comment) {
    // 嘉宾和支持人发言 需要假发数据
    let callback = function (text) { };
    if (this.isSpecialStatus) {
      callback = (json) => {
        // debugger;
        let info = this.getSpecialUserInfo();
        let className = this.presentersInfo[this.uid] ? 'orange' : '';
        let text = transFace(json?.reply?.reply_text);
        let imgstr = json?.reply?.reply_picture ? `<img class="chatimg" src=${json?.reply?.reply_picture}>` : "";
        let html = `<li class="item jiafaChat">
                <div class="avater"><img src="${info.avatar}" alt=""></div>
                <div class="info">
                    <h4 class="name">${info.name} </h4>
                    <p class="time">${dateFormat(new Date(), "yyyy-MM-dd HH:mm")}</p>
                </div>
                <div class="answer_con ${className}">${text}${imgstr}</div>
                </li>`;

        if (this.type === 0) {
          $('.luyan_content>ul').prepend(html);
          // document.body.scrollTop = document.documentElement.scrollTop = 0; // 0
          $('.luyan_content>ul').scrollTop(0);

          $("html, body").animate({ scrollTop: (<any>$(".vedioCtrlBox"))?.offset().top }, 100);
        }
      }
    };
    // 我的提问回调
    let clickToMyQuestionCallback: any = null;
    if (!this.isSpecialStatus) {
      clickToMyQuestionCallback = () => {
        // setTimeout(() => {
        //   $(".luyan_tabs").find(".myquestiontab").trigger("click");
        // }, 500);
      };
    };

    // 非回顾状态下
    if (this.status != 3) {  //  && !!can_comment
      let postparams = {
        thisSe: "#guba_post_editor",
        isReply: false, // 是回复还是发言
        postData: this.getGubaPostData(),
        callback: callback,
        clickToMyQuestion: clickToMyQuestionCallback
      }
      if (_env == 'test') {
        postparams = $.extend(postparams, { env: _env })  ////测试用，发布上线去掉 
      }

      if ((<any>window)?.postEditor) {
        (<any>window).postEditor(postparams);
      }

    } else {
      $('#guba_post_editor').hide();
    }
  },
  /**
   * 返回嘉宾用户头像
   * @param id 通行证id
   */
  getGuestAvatar: function (id) {
    return this.guestsInfo[id] ? this.guestsInfo[id].avatar : `https://avator.eastmoney.com/qface/${id}/120`
  },

  /**
   * 获取嘉宾和主持人用户信息 头像 和 昵称
   * 股吧列表和假发，嘉宾昵称头像取浪客配置的，主持人昵称头像取通行证的
   * @param id 用户uid
   * @param name 默认昵称
   */
  getSpecialUserInfo: function (id = this.uid, name: string = this.name) {
    let res = {
      avatar: `https://avator.eastmoney.com/qface/${id}/120`,
      name: name || "",
      position: "",
      id: ""
    }
    //嘉宾信息
    let item = this.guestsInfo[id];
    if (item) {
      res.avatar = item.avatar;
      res.name = item.target_nickname || item.nickname
      res.position = item?.position || "",
        res.id = item?.id
    }
    return res;
  },
  /**
   * 获取股吧list
   * @param data 
   */
  getGubaListDom: function (data: Array<any>): string {
    let that = this;
    let once = true;

    let domstr = getChatDomList.call(this, {
      list: data,
      guestsId: that.guestsId,
      presentersId: that.presentersId,
      isSpecialStatus: that.isSpecialStatus,
      isLangKeRoom: this.isLangKeRoom, // 浪客
      userIsGuest: this.isguest,
      userIsPresenter: this.isPresenter,
      isAdmin
    })

    return domstr;
  },

  /**
   * 加载股吧列表
   */
  loadGubaList: function (data: Array<any>) {
    // 分页处理  获取最后一条留言id和时间
    let lastItem = data[data.length - 1];
    this.lastid = lastItem?.reply_id;

    // 最后一条的时间处理：如果有回复则取
    this.lasttime = lastItem?.answer_id > 0 ? lastItem?.answer_publish_time : lastItem?.reply_publish_time;

    // 主持人待审核列表和嘉宾待修改列表 都传回复时间answer_publish_time
    if (this.isSpecialStatus && (this.type == 23 || this.type == 32)) {
      this.lasttime = lastItem?.answer_publish_time || "";
    };

    this.operatetime = lastItem?.operate_time;
    this.preListLen = data?.length;

    // console.log("this.lasttime" + this.lasttime)

    this.firstListId = data?.[0]?.reply_id;
    this.firstListAnswerId = data?.[0]?.answer_id;
    let html: string = this.getGubaListDom(data);

    if (this.isFirstLoadList) {
      this.isFirstLoadList = false;
      $('.luyan_content ul').html(html)
    } else {
      $('.luyan_content ul').append(html)
    }

    hideLoading();
  },

  // 校验嘉宾或主持人是否有打开回复:是否处于正在回复中
  checkOnReplyStatus: function () {
    return $("#chatarea").find(".guba_reply_editor")?.length > 0 ? true : false;
  },

  // dom 绑定事件
  event: function () {
    // bindEvens.call(this, _env);
    let that: any = this;

    // 互动区域事件绑定
    bindChatEvens.call(this, accountInfo);

    // 列表切换
    $('.luyan_tabs').on('click', 'li', function () {
      that.type = $(this).data('id');
      that.isFirstLoadList = true;
      that.lastid = '';
      that.lasttime = '';
      that.operatetime = '';
      that.preListLen = 0;
      $('.luyan_content ul').html("")
      showLoading();
      that.getCommentData();
      $(this).addClass('active').siblings().removeClass('active dot');
    });

    //顶部排序刷新
    // $('#refresh').click(function () {
    //   that.refresh();
    // })

    // 排序
    $("#refreshActions").on("click", ".refresh", function () {
      let order = $(this).data("order");
      if (order != undefined) {
        that.ordertype = order;
        $(this).addClass("on").siblings().removeClass("on");
      } else {

      }
      that.refresh();
    });

    // 滚动加载
    $('.luyan_content>ul').scroll(debounce((e) => {
      let element = e.target
      if (element.scrollHeight - element.scrollTop <= element.clientHeight + 100) {
        // if (that.preListLen < 20)return false;  //上一次请求条数 小于请求页数则不继续
        that.getCommentData();
      }
    }));

    // 滚动固顶
    $(window).scroll(function () {
      let rect: { top: number } = $('.luyan_wrap')[0].getBoundingClientRect();
      let rect2: { top: number } = $('#guba_post_editor')[0].getBoundingClientRect();
      // let navHeight = $('.luyan_nav').height();
      let navHeight = 125;

      if (rect.top < 0) {
        $(".luyan_nav").css({
          "position": "fixed",
          "top": "33px",
          "width": "688px",
          "z-index": 20
        })
      } else {
        $(".luyan_nav").removeAttr("style")
      }
      if (rect2.top < navHeight) {
        let newTop = 33 - navHeight + rect2.top;
        $(".luyan_nav").css({
          "top": newTop + "px"
        })
      }
    });

    // 回顾播放点击事件
    $("#vedioCtrlBox").on("click", "#playHuiguVideo", async function () {
      let json = await getLkApi('/api/Roadshow/Detail', {
        channel_id: accountInfo.id
      });

      //展示回顾true
      if (!json?.data?.playback_chapter?.[0]?.media_group?.[0]?.media?.url) {
        tiptoast.show({
          content: "回顾暂未生成，请稍后再试",
          boxid: "#vedioCtrlBox",
          classStyle: "tiptoastabsolute",
          callback: function () { }
        });
      } else {
        that.initLuyanVideo(json.data, "av-player-ctx123");
      }
    });


  }

};

luyan.init();




// 股吧发言框出刷
gbposterbox();


setTimeout(function () {
  sharebox.init();
  smallvedioCtrl();

  // 互动图片预览
  new PreViewPicture({
    imgboxdiv: ".luyan_content",
    imgclass: ".chatimg",
    zindex: 999999,
    scaleRate: 0.8
  })
}, 1000);


